<template>
</template>
<script>
    export default {
        async created() {
            await this.$store.dispatch('users/logout');
            this.$router.push({name: 'Login'});
        }
    }
</script>



// WEBPACK FOOTER //
// Logout.vue?6c6bf122